/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  "iframe-page": () => import("@/views/_builtin/iframe-page/[url].vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  "finance-manage_dashboard": () => import("@/views/finance-manage/dashboard/index.vue"),
  "finance-manage_settlement-manage": () => import("@/views/finance-manage/settlement-manage/index.vue"),
  "finance-manage_withdraw-manage": () => import("@/views/finance-manage/withdraw-manage/index.vue"),
  home: () => import("@/views/home/index.vue"),
  "operators_merchants-list": () => import("@/views/operators/merchants-list/index.vue"),
  "operators_operators-list": () => import("@/views/operators/operators-list/index.vue"),
  "operators_school-list": () => import("@/views/operators/school-list/index.vue"),
  "qrcode-scan": () => import("@/views/qrcode-scan/index.vue"),
  "system-manage_order-simulation-batch": () => import("@/views/system-manage/order-simulation-batch/index.vue"),
  "system-manage_role-manage": () => import("@/views/system-manage/role-manage/index.vue"),
  "system-manage_scope-user-list": () => import("@/views/system-manage/scope-user-list/index.vue"),
  "user-center": () => import("@/views/user-center/index.vue"),
  "users_platform-user-list": () => import("@/views/users/platform-user-list/index.vue"),
  "users_recharge-activities": () => import("@/views/users/recharge-activities/index.vue"),
  "users_user-change-school": () => import("@/views/users/user-change-school/index.vue"),
  "users_water-card-list": () => import("@/views/users/water-card-list/index.vue"),
  "water-service-manage_devices-dashboard": () => import("@/views/water-service-manage/devices-dashboard/index.vue"),
  "water-service-manage_flow-details": () => import("@/views/water-service-manage/flow-details/index.vue"),
  "water-service-manage_outlet-manage": () => import("@/views/water-service-manage/outlet-manage/index.vue"),
  "water-service-manage_outlet-templates": () => import("@/views/water-service-manage/outlet-templates/index.vue"),
  "water-service-manage_water-consume-detail": () => import("@/views/water-service-manage/water-consume-detail/index.vue"),
  "water-service-manage_water-devices-list": () => import("@/views/water-service-manage/water-devices-list/index.vue"),
  "water-service-manage_water-order": () => import("@/views/water-service-manage/water-order/index.vue"),
};
